import type { Preiszuschlag } from "./typen";

/* ══════════════════════════════════════════════════════════════════
   Die Zuschläge an einem Anbauteil mit eigenem Tarif — in der Vorschau.

   P6-03 (letzte Prüfrunde, 05.10.2026): Merkliste und „Jetzt vermieten"
   nannten **73,00**, Auftrag und AB-2026-0007 **98,50**. Die Zubehörzeile
   „Fahrbahnplatte" trägt auf dem Auftrag ihre eigene Versicherung (10,50)
   und ihren Rücknahme-Check (15,00) — so rechnet die Erwartung
   (`dienste/zuschlagserwartung.ts`, „Auch die Anbauteilzeile rechnet ihre
   Zuschläge") und der Lauf (docs/43, 10s/10t). Die Vorschau rechnete nur
   die Miete der Platte.

   **Gerechnet wird nicht hier, sondern geholt** (Regel 4): Die Zuschläge
   kommen aus derselben Preisauskunft, die den Satz der Platte nennt
   (`GET /preis` für den Anbauteiltyp — dort `fach.zuschlaegeRechnen` mit
   den Regeln des Typs, derselbe Kern wie `fach.zuschlaegeErwartet` in der
   Erwartung). Hier wird nur ausgewählt und zusammengezählt:

   - **„Einmal je Auftrag" zählt nicht noch einmal** — die Anlieferung steht
     schon am Träger und auf dem Auftrag nur einmal (`zuschlaegeZusammenfassen`).
   - **Prozentzuschläge wachsen mit den Stücken**: Die Auskunft rechnet sie
     auf die Miete **eines** Stücks; die Zubehörzeile trägt die Miete aller
     Stücke (`anbauteilePreisen`, Menge × Stücke).
   - Alles andere gilt **einmal je Zeile**: Die Versicherung je Miettag ×
     Miettage, der Rücknahme-Check einmal — zwei Platten sind eine Zeile.
   ══════════════════════════════════════════════════════════════════ */

const geld = (betrag: number): number => Math.round(betrag * 100 + 1e-9) / 100;

/** Was die Zuschläge einer Zubehörzeile kosten — netto, für alle Stücke der Zeile. */
export function anbauZuschlaege(zuschlaege: readonly Preiszuschlag[], stuecke: number): number {
  let summe = 0;
  for (const z of zuschlaege) {
    if (z.jeAuftrag) continue;
    const prozent = z.schritte.some((s) => s.key === "zuschlag.prozent");
    summe += prozent ? z.netto * Math.max(1, stuecke) : z.netto;
  }
  return geld(summe);
}
